import React from 'react';
import { ListProps, List, Spin } from 'antd';
import InfiniteScroll, {
  type Props as InfinitiveProps
} from 'react-infinite-scroll-component';
import Item from './Item';

type InfinitiveListProps<T> = Partial<ListProps<T>> & {
  infinitiveConfig: Partial<InfinitiveProps>;
  itemHeight?: number;
  loaderRef: React.MutableRefObject<HTMLDivElement | null>;
};

const InfinitiveList = <T,>(props: InfinitiveListProps<T>) => {
  const {
    infinitiveConfig,
    dataSource,
    renderItem,
    loaderRef,
    itemHeight = 250,
    ...listProps
  } = props;

  return (
    <div style={{ height: '100%' }}>
      <InfiniteScroll
        dataLength={dataSource.length}
        next={function () {
          throw new Error('Function not implemented.');
        }}
        loader={
          <div ref={loaderRef} style={{ width: '100%', textAlign: 'center' }}>
            <Spin spinning tip="Loading More Data" />
          </div>
        }
        hasMore={true}
        {...infinitiveConfig}
      >
        <List
          dataSource={dataSource}
          renderItem={(record: T, index) => {
            return (
              <Item<T>
                height={itemHeight}
                renderItem={() => {
                  return renderItem(record, index);
                }}
                item={record}
                index={index}
              />
            );
          }}
          {...listProps}
        />
      </InfiniteScroll>
    </div>
  );
};

export default InfinitiveList;
